"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetAttributesEnumeration {
    static getAttributeTypeMap() {
        return GetAttributesEnumeration.attributeTypeMap;
    }
}
GetAttributesEnumeration.discriminator = undefined;
GetAttributesEnumeration.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "number"
    },
    {
        "name": "label",
        "baseName": "label",
        "type": "string"
    }
];
exports.GetAttributesEnumeration = GetAttributesEnumeration;
//# sourceMappingURL=getAttributesEnumeration.js.map